import { FANTASY_ACTION_TYPES, } from './fantasyActionTypes';


const { TOURNAMENT, } = FANTASY_ACTION_TYPES;
const NUM_TOURNAMENTS_INC = 2;
const INITIAL_NUM_TOURNAMENTS_VISIBLE = 2;
const DEFAULT_STATE = {
  isInitialized: false,
  isLoadMoreVisible: true,
  numVisibleTournaments: INITIAL_NUM_TOURNAMENTS_VISIBLE,
};

function incVisibleFeedSize(state, newState){
  const numTotalTournaments = state.tournaments.length;
  const numVisibleTournaments = state.numVisibleTournaments + NUM_TOURNAMENTS_INC;
  const isLoadMoreVisible = numVisibleTournaments < numTotalTournaments;
  return { ...state, ...newState, numVisibleTournaments, isLoadMoreVisible, };
}

function reduceGetTournamentsFeed(state, newState){
  const isLoadMoreVisible = state.numVisibleTournaments < newState.tournaments.length;
  return { ...state, ...newState, isLoadMoreVisible, };
}

export function fantasyReducer(state = DEFAULT_STATE, action){
  switch (action.type) {
    case TOURNAMENT.GET_TOURNAMENTS_FEED:
      return reduceGetTournamentsFeed(state, action.state);
    case TOURNAMENT.LOAD_MORE:
      return incVisibleFeedSize(state, action.state);
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/fantasyReducer.js